import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const Ctx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  useEffect(() => {
    if (!localStorage.getItem("access_token")) return setUser(false);
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => { localStorage.removeItem("access_token"); setUser(false); });
  }, []);
  const login = (data) => { localStorage.setItem("access_token", data.access_token); setUser(data.user); };
  const logout = async () => { try { await api.post("/auth/logout"); } catch {} localStorage.removeItem("access_token"); setUser(false); };
  return <Ctx.Provider value={{ user, login, logout }}>{children}</Ctx.Provider>;
}

export const useAuth = () => useContext(Ctx);
